import tw, { styled } from 'twin.macro';

export const HeroContainer = styled.div`
  ${tw`
    px-12
    pt-36
    pb-10
    relative
    overflow-hidden
    flex
    flex-col
    justify-end
  `}
  height: 80vh;
  background-size: cover !important;
  ${(props) => (props.backgroundUrl
    ? `background: url('${props.backgroundUrl}');`
    : 'background: #111;')}
  background-position: ${(props) => props.$backgroundPosition || 'center'};
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.5) 45%, rgba(0,0,0,0.15) 100%),
      linear-gradient(0deg, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 40%);
  }
  > * {
    position: relative;
    z-index: 1;
  }

  @media (min-width: 1600px) {
    height: 85vh;
    padding-left: 5.5rem;
    padding-right: 5.5rem;
  }

  @media (max-width: 900px) {
    height: 70vh;
    padding-left: 2rem;
    padding-right: 2rem;
    padding-top: 8rem;
    padding-bottom: 2.5rem;
  }

  @media (max-width: 600px) {
    height: 62vh;
    padding-left: 1.25rem;
    padding-right: 1.25rem;
    padding-top: 6.5rem;
  }
`;

export const HeroTitle = styled.h1`
  ${tw`
    text-6xl
    font-bold
    mb-4
  `}
  text-shadow: 3px 3px 6px black;
  max-width: 52rem;

  @media (min-width: 1600px) {
    font-size: 4.5rem;
  }

  @media (max-width: 900px) {
    font-size: 3rem;
  }

  @media (max-width: 600px) {
    font-size: 2.25rem;
  }
`;

export const HeroMeta = styled.div`
  ${tw`
    mb-4
    flex
    flex-col
    gap-2
  `}
`;

export const HeroBadgeRow = styled.div`
  ${tw`
    flex
    items-center
    gap-3
    text-base
    font-semibold
  `}
`;

export const HeroBadgeIcon = styled.img`
  ${tw`
    w-10
    h-10
  `}
`;

export const HeroMetaRow = styled.div`
  ${tw`
    flex
    flex-wrap
    items-center
    gap-3
    text-sm
    font-semibold
  `}
`;

export const HeroMetaText = styled.span`
  ${tw`
    text-white
  `}
  ${(props) => (props.$highlight ? 'color: #46d369;' : '')}
`;

export const HeroMetaBadge = styled.span`
  ${tw`
    text-sm
    font-bold
    px-3
    py-1
    rounded
  `}
  background-color: rgba(70, 70, 70, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: #e5e7eb;
`;

export const HeroDescription = styled.p`
  ${tw`
    font-medium
    text-base
    mb-4
  `}
  text-shadow: 2px 2px 2px black;
  width: 38rem;
  max-width: 80vw;
  line-height: 1.3;

  @media (max-width: 900px) {
    width: 28rem;
  }

  @media (max-width: 600px) {
    width: auto;
    max-width: 90vw;
    font-size: 0.95rem;
  }
`;

export const HeroButtonRow = styled.div`
  ${tw`
    flex
    items-center
    gap-3
  `}
`;

export const HeroButton = styled.button`
  ${tw`
    cursor-pointer
    font-bold
    rounded
    px-4
    py-1.5
    inline-flex
    items-center
    gap-2
    text-sm
  `}
  ${(props) => (props.$variant === 'primary'
    ? 'background-color: #f5f5f5; color: #111; box-shadow: 0 0 0 1px rgba(255,255,255,0.2);'
    : 'background-color: rgba(51, 51, 51, 0.55); color: #fff;')}
  &:hover {
    background-color: #e6e6e6;
    color: #111;
    transition: all 0.2s;
  }
`;

export const HeroInfoIcon = styled.span`
  ${tw`
    inline-flex
    items-center
    justify-center
    w-5
    h-5
    rounded-full
    text-xs
    font-bold
  `}
  border: 2px solid rgba(255, 255, 255, 0.9);
`;

export const HeroNavControls = styled.div`
  ${tw`
    mt-6
    flex
    items-center
    gap-3
  `}
`;

export const HeroNavButton = styled.button`
  ${tw`
    w-11
    h-11
    rounded-full
    flex
    items-center
    justify-center
    text-xl
    font-bold
  `}
  background-color: rgba(17, 17, 17, 0.75);
  border: 1px solid rgba(255, 255, 255, 0.2);
  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
`;
